__turbopack_context__.v({
  "importantCard": "ImportantThingsSection-module__Zwm-9G__importantCard",
  "importantCardBody": "ImportantThingsSection-module__Zwm-9G__importantCardBody",
  "importantCardHeader": "ImportantThingsSection-module__Zwm-9G__importantCardHeader",
  "importantCardTitle": "ImportantThingsSection-module__Zwm-9G__importantCardTitle",
  "importantGrid": "ImportantThingsSection-module__Zwm-9G__importantGrid",
  "importantIcon": "ImportantThingsSection-module__Zwm-9G__importantIcon",
  "importantIconWrap": "ImportantThingsSection-module__Zwm-9G__importantIconWrap",
  "importantLinkBtn": "ImportantThingsSection-module__Zwm-9G__importantLinkBtn",
  "importantLinks": "ImportantThingsSection-module__Zwm-9G__importantLinks",
  "importantList": "ImportantThingsSection-module__Zwm-9G__importantList",
  "importantListItem": "ImportantThingsSection-module__Zwm-9G__importantListItem",
  "importantSection": "ImportantThingsSection-module__Zwm-9G__importantSection",
  "linkBtnFadeIn": "ImportantThingsSection-module__Zwm-9G__linkBtnFadeIn",
});
